import React from "react";
import { Badge, HStack, Tooltip } from "@chakra-ui/react";
import { RiArchiveLine } from "@react-icons/all-files/ri/RiArchiveLine";
import { RiSeedlingLine } from "@react-icons/all-files/ri/RiSeedlingLine";

type CourseStatusLabelProps = {
  status: string;
};

type StatusPropsType = {
  color: string;
  label: string;
  icon?: JSX.Element;
};

const StatusProps = {
  beta: {
    color: "blue",
    label:
      "🌱 This course is currently in BETA. Some content may be incomplete and subject to change. We would appreciate any feedback as we work to improve the course.",
    icon: <RiSeedlingLine />,
  },
  deprecated: {
    color: "gray",
    label: "This course has been deprecated. Some content may be outdated.",
    icon: <RiArchiveLine />,
  },
  "Coming soon": {
    color: "blue",
    label: "🛠️ This course is not yet available.",
  },
};

export default function CourseStatusLabel({ status }: CourseStatusLabelProps) {
  const { color, label, icon } = (
    StatusProps as { [index: string]: StatusPropsType }
  )[status];
  return (
    <Tooltip label={label} placement="right">
      <Badge
        lineHeight="tall"
        fontFamily="mono"
        rounded="full"
        px="2"
        ml="2"
        colorScheme={color}
      >
        <HStack spacing="1">
          {icon}
          <span>{status}</span>
        </HStack>
      </Badge>
    </Tooltip>
  );
}
